export enum TraceId {
  CLAIM_NONCE = "claimNonce",
  VERIFY_ACCOUNT = "verifyAccount",
  CREATE_SIGNATURE = "createSignature",
  REFRESH_TOKEN = "refreshToken",
  FAUCE_CLAIM = "faucetClaim",
  FREE_TRIAL_INFO = "freeTrialInfo"
}
